<template>
	<div id="sns" class="snsButton">
		<div id="tweetBtn" class="snsButton__btn snsButton__twitter"></div>
		<div id="fbLike" class="snsButton__btn snsButton__facebook"></div>
		<div id="pinit" class="snsButton__btn snsButton__pinterest">
			<a class="pinbtn" v-on:click.prevent="pinit()">保存</a>
		</div>
	</div>
</template>

<script>
module.exports = {
	route: {
		data: function(transition){
		},
		canReuse: false
	},
	data: function () {
		return {
			pageMeta: this.$parent.pageMeta
		};
	},
	created: function(){
		// console.log('sns_buttons created');
	},
	beforeCompile: function(){
		// console.log('sns_buttons beforeCompile');
	},
	ready: function () {
		// console.log('sns_buttons ready');

		// twitter
		this.addTweetBtn();

		// facebook
		this.addFbLikeBtn2();

		// pinterest
	},
	beforeDestroy: function () {
		// console.log('sns_buttons beforeDestroy');
	},
	methods: {
		addTweetBtn: function(){
			var title = this.$parent.profile.name + ' | ' + this.pageMeta.title_short;
			window.twttr.ready(function(twttr){
				window.twttr.widgets.createShareButton(
					window.location.href,
					document.getElementById('tweetBtn'),
					{
						lang: 'ja',
						count: 'none',
						text: title
					}
				).then(function (el) {
					// console.log('Button created.');
				});
			});
		},
		addFbLikeBtn2: function(){
			var insertTarget = document.getElementById('fbLike');
			var fblikeBtn = document.createElement('iframe');
			var url = this.pageMeta.url;
			fblikeBtn.setAttribute('src', 'https://www.facebook.com/plugins/like.php?href=' + url + '&width=72&layout=button&action=like&size=small&show_faces=false&share=false&height=65&appId');
			fblikeBtn.setAttribute('width', '72');
			fblikeBtn.setAttribute('height', '65');
			fblikeBtn.setAttribute('style', 'border:none;overflow:hidden');
			fblikeBtn.setAttribute('scrolling', 'no');
			fblikeBtn.setAttribute('frameborder', '0');
			fblikeBtn.setAttribute('allowTransparency', 'true');

			insertTarget.appendChild(fblikeBtn);
		},
		pinit: function(){
			window.PinUtils.pinAny();
		}
	}
};
</script>

<style scoped lang="scss">
/*.pinbtn{
	font: 11px/20px "Helvetica Neue", Helvetica, sans-serif;
	font-weight: bold;
	-webkit-font-smoothing: antialiased;
	color: #fff;
	line-height: 20px;
	// vertical-align: baseline;
	// text-align: center;
	text-indent: 20px;
	text-decoration: none;
	box-sizing: border-box;
	box-shadow: inset 0 0 1px #888;
	border: 0;
	border-radius: 2px;
	background: url('/static/images/snsButton/pinit.svg') 3px 50% no-repeat #bd081c;
	background-size: 14px 14px;
	display: inline-block;
	padding: 0 4px 0 0;
	cursor: pointer;

	&:hover{
		background-color: #aa0719;
	}
}*/
</style>



// WEBPACK FOOTER //
// sns_buttons.vue?7a39d64c